import { DateTime } from "luxon";
import i18next from "i18next";
import { MANITOBA_TIMEZONE } from "Constants/TimeConstants";

export const getLocalizedStatus = (status, t) => {
  const statusTranslations = {
    BOOKED: t("appointmentStatus.booked"),
    BOOKED_BY_MBS: t("appointmentStatus.bookedByMBS"),
    COMPLETED: t("appointmentStatus.completed"),
    UNKNOWN: t("appointmentStatus.unknown"),
    MOVED: t("appointmentStatus.moved"),
    MOVED_BY_CLINIC: t("appointmentStatus.movedByClinic"),
    MOVED_BY_PATIENT: t("appointmentStatus.movedByPatient"),
    MOVED_BY_MBS: t("appointmentStatus.movedByMBS"),
    CANCELLED: t("appointmentStatus.cancelled"),
    CANCELLED_BY_CLINIC: t("appointmentStatus.cancelledByClinic"),
    CANCELLED_BY_PATIENT: t("appointmentStatus.cancelledByPatient"),
    CANCELLED_BY_MBS: t("appointmentStatus.cancelledByMBS"),
  };

  return statusTranslations[status] || status;
};

export const getLocalizedDate = (date, format, t) => {
  const locale = i18next.language || "en";
  const formats = {
    "MMM d": { en: "MMM d", fr: "d MMM" },
    "MMMM dd, yyyy": { en: "MMMM dd, yyyy", fr: "dd MMMM yyyy" },
    "cccc, MMM d": { en: "cccc, MMM d", fr: "cccc, d MMM" },
    "cccc, MMMM dd, yyyy": {
      en: "cccc, MMMM dd, yyyy",
      fr: "cccc, dd MMMM yyyy",
    },
  };
  const defaultFormat = "MMMM dd, yyyy";

  const localizedFormat =
    formats[format]?.[locale] || formats[defaultFormat][locale];

  const today = DateTime.now().setZone(MANITOBA_TIMEZONE);
  const inputDate = DateTime.fromISO(date);

  // Add today and tomorrow logic for "cccc, MMM d" format
  if (format === "cccc, MMM d") {
    if (date === today.toISODate()) {
      return `${t("dates.today")}, ${inputDate
        .setLocale(locale)
        .toFormat(formats["MMM d"][locale])}`;
    } else if (date === today.plus({ days: 1 }).toISODate()) {
      return `${t("dates.tomorrow")}, ${inputDate
        .setLocale(locale)
        .toFormat(formats["MMM d"][locale])}`;
    }
  }

  return inputDate.setLocale(locale).toFormat(localizedFormat);
};

export const getLocalizedDateCard = (date, time, t) => {
  const locale = i18next.language || "en";
  const inputDate = date
    ? DateTime.fromISO(date, { zone: MANITOBA_TIMEZONE })
    : null;

  if (!inputDate || !inputDate.isValid) {
    return {
      dateLabel: "",
      day: "",
      month: "",
      time: "",
    };
  }

  const today = DateTime.now().setZone(MANITOBA_TIMEZONE);
  const isToday = inputDate.hasSame(today, "day");
  const localizedDate = inputDate.setLocale(locale);

  return {
    dateLabel: isToday ? t("dates.today") : localizedDate.toFormat("cccc"),
    day: localizedDate.toFormat("d"),
    month: localizedDate.toFormat("LLLL"),
    time: time ? getLocalizedTime(time) : "",
  };
};

export const getLocalizedTime = (time, format) => {
  const locale = i18next.language || "en";
  const formats = {
    "hh:mm a": { en: "hh:mm a", fr: "HH:mm" },
  };
  const defaultFormat = "hh:mm a";
  const localizedFormat =
    formats[format]?.[locale] || formats[defaultFormat][locale];

  return DateTime.fromFormat(time, "hh:mm a")
    .setLocale(locale)
    .toFormat(localizedFormat);
};
